import React from 'react';
import { useTranslation } from 'react-i18next';
import { messageType } from '../../types';
import DateTime, { LONG_DATETIME } from '../DateTime';
import './_styles_/MessageRow.css';
import transformMessage from './messageTransformer';

MessageRow.propTypes = {
    message: messageType.isRequired,
};

function MessageRow(props) {
    const {
        message,
    } = props;
    const { i18n } = useTranslation();
    return (
        <div className="rich-list-row message-header">
            <div className="message-header--values--last-update-time readonly"><DateTime value={message.lastUpdateTime} format={LONG_DATETIME} /></div>
            <div className="message-header--values--message readonly">{transformMessage(i18n, message.messageKey, message.params)}</div>
        </div>
    );
}

export default MessageRow;
